import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    ProviderSearchContext,
    ProviderSearchCriteria,
    defaultProviderSearchCriteria,
} from "utilities/contexts/search/provider/provider-search-context";

interface AdminProviderLayoutProps {}

// Keeps ProviderSearchCriteria in scope across the AEN providers list page and its detail routes, without leaking to other admin sections.
const AdminProviderLayout: React.FC<AdminProviderLayoutProps> = (): JSX.Element => {
    const [providerSearchCriteria, setProviderSearchCriteria] = useState<ProviderSearchCriteria>(
        defaultProviderSearchCriteria
    );

    return (
        <ProviderSearchContext.Provider
            value={{ initialCriteria: providerSearchCriteria, setCriteria: setProviderSearchCriteria }}>
            <Outlet />
        </ProviderSearchContext.Provider>
    );
};

export { AdminProviderLayout };
